<template>
<!-- v-if="dataArray.length>0" -->
  <div class="">
    <Datatable :api-params="paramsComputed" :api-url="'household/getHouseSurvey'" :method-request="'POST'" :data-array-table="dataArrayTable" :router-name="'household'" :key="key" :default-sort="[{field:'_id',dir:'desc'}]" :custom-sort="[{column: 'head_name', relateColumn: ['head_surname']},{column: 'hnum', relateColumn: ['moo','village_name','soi','road','tumbol_name','amphur_name','province_name']}]" @rowClick="router.push({name: 'household-profile',params: {hhid: $event._id}})"/>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
import Datatable from "@/components/datatable/index.vue"
import {useStore} from "vuex"
import { useRouter } from 'vue-router'

export default defineComponent({
  props:{
    filter:{
      type: Object
    },
    reloadTable:{
      type: Boolean,
      default: false
    }
  },
  components:{
    Datatable
  },
  setup(props) {
    let dataArray = ref([])
    const store = useStore()
    const filterValue = ref()
    const params = ref({start: '1',draw: '1',length: '10'})
    const key = ref(1)
    const router = useRouter()
    watch(()=>props.filter, ()=>{
      key.value++
    })
    watch(()=>props.reloadTable,(val)=>{
      if(val){
        key.value++
      }
    })
    const paramsComputed = computed(() => ({...params.value, ...props.filter}))
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.head_title ? data.head_title : ""}${data.head_name ? data.head_name : ""} ${data.head_surname ? data.head_surname : ""}`
    }
    var customAddressMutator = (value, data, type, params, component) => {
      return `${data.hnum ? data.hnum:""} ${data.moo?'หมู่ '+data.moo:""} ${data.village_name?data.village_name: ""} ${data.soi?'ซอย '+data.soi: ""} ${data.road?'ถนน '+data.road: ""} ${data.tumbol_name?'ตำบล'+data.tumbol_name: ""}  ${data.amphur_name?'อำเภอ'+data.amphur_name: ""} ${data.province_name?'จังหวัด'+data.province_name: ""} ${data.postcode ? data.postcode : ""}`
    }
    var customProblemMutator = (value, data, type, params, component) => {
      return {"family": data.prob_family, "health": data.prob_health, "occupation": data.prob_occupation, "education": data.prob_education, "accessibility": data.prob_accessibility}
    }
    const dataArrayTable = reactive([
      {title:"หัวหน้าครัวเรือน", field:"head_name", resizable:true, formatter:"textarea", minWidth: 200, mutator: customNameMutator},
      {title:"ที่อยู่", field:"hnum", hozAlign:"left", formatter:"textarea", resizable:true, minWidth: 300, mutator: customAddressMutator},
      {title:"สภาพปัญหา", field:"problems", resizable:true, minWidth: 220, mutator: customProblemMutator, variableHeight: true,
        formatter:function(cell, formatterParams){
          var value = cell.getValue();
          let res = `<div class="flex flex-wrap">\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.health > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">สุขภาพอนามัย</span>\
                        <span class="img-icon heart-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.family > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">ครอบครัว</span>\
                        <span class="img-icon home-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.occupation > 0 ? 'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การมีงานทำและมีรายได้</span>\
                        <span class="img-icon dollar-sign-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.accessibility > 0 ? 'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม</span>\
                        <span class="img-icon card-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.education > 0 ? 'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การศึกษา</span>\
                        <span class="img-icon book-open-icon"></span>\
                      </button>\
                    </div>`
          return res
        }
      },
      {title:"ลักษณะครัวเรือน", field:"hh_type", hozAlign:"center", resizable:true, minWidth: 160, width: 160,
        formatter:function(cell, formatterParams){
          if(cell.getValue() == "ครัวเรือนขยาย (พ่อ แม่ ลูก พี่ น้อง ปู่ ย่า ตา ยาย หลาน)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครัวเรือนขยาย\
              </button>"
          }
          else if(cell.getValue() == "ครัวเรือนเดี่ยว (พ่อ แม่ ลูก)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครัวเรือนเดี่ยว\
              </button>"
          }
          else{
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              อยู่คนเดียว\
              </button>"
          }
        }
      },
      {title:"จำนวนครอบครัว", field:"fam_cnt", hozAlign:"center", resizable:true, minWidth: 150, width: 150},
      {title:"จำนวนสมาชิก", field:"member_cnt", hozAlign:"center", resizable:true, minWidth: 150, width: 150},
      {title:"พิกัด", field:"latitude", hozAlign:"center", resizable:true, minWidth: 80, width: 100,
        formatter:function(cell, formatterParams){
          var value = cell.getValue();
          let iconAddr = `<span class="coordinate-icon m-auto w-8 h-8 p-2 flex justify-center items-center ${value?'bg-theme-17':'bg-theme-37'} dark:bg-theme-26 text-white rounded-full"><span class="img-icon map-pin-icon"></span>\</span>`
          return iconAddr
        }
      },
    ])
    return{
      dataArray,
      dataArrayTable,
      params,
      key,
      paramsComputed,
      router
    }
  }
})
</script>
<style lang="scss">
</style>

